<div class="td-card td-statements-card">
  <div class="td-card-header">
    <span class="td-card-title">{{ 'td_statements_title' | translate }}</span>
    <div class="td-statements-filters">
      <p-dropdown [options]="sortOptions"
                  [(ngModel)]="sortValue"
                  placeholder="{{ 'td_statements_sort_placeholder' | translate }}"
                  optionLabel="label" optionValue="value"
                  dropdownIcon="bi bi-caret-down-fill"
                  styleClass="td-filter-dropdown"
                  panelStyleClass="td-filter-dropdown-panel"
                  (onChange)="onSortChange()">
        <ng-template let-sort pTemplate="selectedItem">
          <span class="td-sort-selected">
            <span>{{ sort.label }}</span>
            <i class="bi bi-x-lg td-sort-clear" (click)="clearSort($event)"></i>
          </span>
        </ng-template>
      </p-dropdown>
      <p-dropdown [options]="periodOptions"
                  [(ngModel)]="periodValue"
                  optionLabel="label" optionValue="value"
                  dropdownIcon="bi bi-caret-down-fill"
                  styleClass="td-filter-dropdown"
                  panelStyleClass="td-filter-dropdown-panel"
                  (onChange)="onPeriodChange($event)">
        <ng-template pTemplate="selectedItem">
          <span class="td-sort-selected">
            <span>{{ periodLabel }}</span>
            <i class="bi bi-x-lg td-sort-clear" *ngIf="hasCustomRange" (click)="clearRange($event)"></i>
          </span>
        </ng-template>
        <ng-template let-option pTemplate="item">
          <span class="td-period-item" (click)="onPeriodItemClick(option)">{{ option.label }}</span>
        </ng-template>
      </p-dropdown>
    </div>
  </div>

  <div class="td-statements-range" *ngIf="showCustomRange">
    <span class="td-statements-range-label">{{ 'td_statements_from' | translate }}</span>
    <p-calendar [(ngModel)]="rangeStart" dateFormat="dd.mm.yy" [showIcon]="true" icon="bi bi-calendar"
                styleClass="td-statements-calendar" appendTo="body"
                (onSelect)="onRangeDateChange()"></p-calendar>
    <span class="td-statements-range-label">{{ 'td_statements_to' | translate }}</span>
    <p-calendar [(ngModel)]="rangeEnd" dateFormat="dd.mm.yy" [showIcon]="true" icon="bi bi-calendar"
                styleClass="td-statements-calendar" appendTo="body"
                (onSelect)="onRangeDateChange()"></p-calendar>
    <button type="button" class="td-statements-apply" [disabled]="!canApplyRange"
            (click)="applyCustomRange()">{{ 'td_statements_apply' | translate }}</button>
  </div>

  <div class="spinner-border text-primary td-statements-spinner" role="status" *ngIf="loading"></div>

  <ng-container *ngIf="!loading">
    <div class="td-statements-list">
      <div class="td-statement"
           *ngFor="let statement of data?.items; let index = index; trackBy: trackByUuid">
        <p-accordion collapseIcon="bi bi-chevron-up" expandIcon="bi bi-chevron-down"
                     (onOpen)="onStatementOpen(statement, index)"
                     (onClose)="onStatementClose(index)">
          <p-accordionTab [selected]="selectedTabs[index]"
                          transitionOptions="300ms cubic-bezier(.25,.8,.25,1)">
            <ng-template pTemplate="header">
              <div class="td-statement-row">
                <img class="td-statement-bubble" [src]="statement.icon" alt="">
                <span class="td-statement-title">{{ statement.title }}</span>
                <div class="td-statement-score">
                  <ng-container *ngIf="statement.score !== null && statement.type !== 'ranked'
                                       && statement.type !== 'single' && statement.type !== 'open'">
                    <span class="td-statement-score-value">{{ statement.score }}%</span>
                    <p-chart type="doughnut" [data]="statementCharts[index]" [options]="chartOptions"
                             [responsive]="true" [style]="{'width': '5rem', 'margin-bottom':'1rem'}"></p-chart>
                  </ng-container>
                </div>
                <span class="td-statement-trend" *ngIf="statement.trend"
                      [ngClass]="statement.trend">
                  <img [src]="'../../../assets/svg/indicator-arrow-' + statement.trend + '.svg'" alt="">
                  <span>{{ statement.diff }}%</span>
                </span>
                <span class="td-statement-trend flat" *ngIf="!statement.trend">
                  <i *ngIf="statement.type === 'scaled'" class="bi bi-dash-lg"></i>
                  <span *ngIf="statement.type === 'scaled'">%</span>
                </span>
                <div class="td-statement-responses">
                  <img [src]="statement.responses === 0 ? '../../../assets/svg/checkin-user-icon0.svg'
                                                        : '../../../assets/svg/checkin-user-icon.svg'" alt="">
                  <span>({{ statement.responses }})</span>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="content">
              <div class="td-statement-content">
              <ng-container *ngIf="statement.type === 'scaled' || statement.type === 'single'">
                <h4 class="td-statement-note" *ngIf="statement.type === 'scaled' && statement.score === null">
                  {{ 'insights_blue_statement' | translate }}
                </h4>
                <ng-container *ngIf="statement.type === 'single' || statement.score !== null">
                  <app-scaled-distribution-bars *ngIf="responseDistribution && statement.type === 'single'"
                                                [responseDistributionObs]="responseDistribution">
                  </app-scaled-distribution-bars>
                  <app-scaled-question-distribution *ngIf="responseDistribution && statement.type === 'scaled'"
                                                    [responseDistributionObs]="responseDistribution">
                  </app-scaled-question-distribution>
                  <div class="spinner-border text-primary td-statements-spinner" role="status"
                       *ngIf="!responseDistribution"></div>
                </ng-container>
              </ng-container>

              <h4 class="td-statement-note" *ngIf="statement.type === 'ranked' && statement.rating === null">
                {{ 'insights_blue_statement' | translate }}
              </h4>
              <div class="td-statement-rating" *ngIf="statement.type === 'ranked' && statement.rating !== null">
                <h4 class="td-statement-note">
                  {{ 'td_statements_rating_description' | translate }}
                </h4>
                <div class="td-statement-rating-box">
                  <h4 class="td-statement-rating-value">{{ statement.rating }}</h4>
                  <h4 class="td-statement-rating-label">
                    {{ 'custom_poll_main_reporting_rating' | translate }}
                  </h4>
                </div>
              </div>

              <ng-container *ngIf="statement.type === 'open'">
                <div class="td-statement-answers-count" *ngIf="openResponses.length">
                  <span>{{ responsesCount }} {{ 'team_member_responses' | translate }}</span>
                </div>
                <div class="td-statement-answers" *ngIf="openResponses.length">
                  <div class="td-statement-answer" *ngFor="let response of openResponses">
                    <span>{{ response.response?.title }}</span>
                  </div>
                </div>
                <span class="td-statement-empty" *ngIf="!openResponses.length">{{ 'td_no_data' | translate }}</span>
              </ng-container>

              <span class="td-statement-empty"
                    *ngIf="statement.type !== 'scaled' && statement.type !== 'single'
                           && statement.type !== 'open' && statement.type !== 'ranked'">
                {{ 'td_statements_no_breakdown' | translate }}
              </span>
              </div>
            </ng-template>
          </p-accordionTab>
        </p-accordion>
      </div>
    </div>

    <span class="td-statement-empty" *ngIf="!data?.items?.length">{{ 'td_no_data' | translate }}</span>
  </ng-container>
</div>
